<template>
  <div class="reports-dashboard">
    <div class="container mt-5 mb-5">
      <div class="row">
        <div class="col-md-4 mt-4 mb-4" v-for="report in reports" :key="report.id">
          <router-link
            :to="{ name: report.router_link, params: {marca: report.title, id_provider: report.id_provider } }"
            class="card-adela-anchor"
          >
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:#513692">
                <font-awesome-icon :icon="['fa', report.icon]" />
              </div>
              <div class="card-adela-category">
                <h2>{{ report.title }}</h2>
                <span>{{ report.description }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 mt-4 mb-4">
          <router-link
            :to="{ name: 'buyListAlmacen'}"
            class="card-adela-anchor"
          >
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:red">
                <font-awesome-icon :icon="['fa', 'box-open']" />
              </div>
              <div class="card-adela-category">
                <h2>Almacenes</h2>
                <span>Realizar compra de los diferentes almacenes</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'

export default {
  mixins: [formatData],
  data () {
    return {
      reports: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async getProviders () {
      try {
        const items = {
          status: 8, // estado de compra o pedido depurado,
          enterprise_id: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getOrdersForProvider', items)
        console.log('', response)
        if (response.status === 200) {
          if (response.data.totalRecords > 0) {
            response.data.rows.forEach(marca => {
              const idNext = this.reports.length + 1
              console.log('Catidad de elementos', this.reports.length, idNext)
              if (marca !== '') {
                this.reports.push({
                  id: idNext,
                  icon: 'cash-register',
                  title: marca.name,
                  type: marca.name,
                  id_provider: marca.id_provider,
                  description: `Todos los pedidos de la marca ${marca.name}.`,
                  router_link: 'buyList',
                  subject: 'GeneralReport'
                })
              }
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.getProviders()
  }
}
</script>
